//All Documents
import {
  GET_DOCUMENTS_REQUEST,
  GET_DOCUMENTS_SUCCESS,
  GET_DOCUMENTS_ERROR,
} from "../../actions/documents/getDocuments";

//Document
import {
  GET_DOCUMENT_REQUEST,
  GET_DOCUMENT_SUCCESS,
  GET_DOCUMENT_ERROR,
} from "../../actions/documents/getDocument";

//Update Document
import {
  PUT_DOCUMENT_REQUEST,
  PUT_DOCUMENT_SUCCESS,
  PUT_DOCUMENT_ERROR,
} from "../../actions/documents/putDocument";

//Create Document
import {
  POST_DOCUMENT_REQUEST,
  POST_DOCUMENT_SUCCESS,
  POST_DOCUMENT_ERROR,
} from "../../actions/documents/postDocument";

//Logout
import { LOGOUT } from "../../../auth/actions/logout";

const INITIAL_STATE = {
  loading: false,
  loadingAction: false,
  error: false,
  data: [],
  pagination: {
    current_page: 0,
    last_page: 0,
    per_page: 0,
    total: 0,
  },
  detail: {},
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_DOCUMENTS_REQUEST:
      return {
        ...state,
        error: false,
        loading: true,
      };
    case GET_DOCUMENTS_SUCCESS:
      return {
        ...state,
        ...action.payload,
        error: false,
        loading: false,
      };
    case GET_DOCUMENTS_ERROR:
      return {
        ...state,
        error: action.payload || action.payload.status || 401,
        loading: false,
      };
    case GET_DOCUMENT_REQUEST:
      return {
        ...state,
        error: false,
        loading: true,
      };
    case GET_DOCUMENT_SUCCESS:
      return {
        ...state,
        detail: action.payload,
        error: false,
        loading: false,
      };
    case GET_DOCUMENT_ERROR:
      return {
        ...state,
        error: action.payload || action.payload.status || 401,
        loading: false,
      };
    case PUT_DOCUMENT_REQUEST:
      return {
        ...state,
        error: false,
        loadingAction: true,
      };
    case PUT_DOCUMENT_SUCCESS:
      return {
        ...state,
        error: false,
        loadingAction: false,
      };
    case PUT_DOCUMENT_ERROR:
      return {
        ...state,
        error: action.payload || action.payload.status || 401,
        loadingAction: false,
      };
    case POST_DOCUMENT_REQUEST:
      return {
        ...state,
        error: false,
        loading: true,
      };
    case POST_DOCUMENT_SUCCESS:
      return {
        ...state,
        error: false,
        loading: false,
      };
    case POST_DOCUMENT_ERROR:
      return {
        ...state,
        error: action.payload || action.payload.status || 401,
        loading: false,
      };
    case LOGOUT:
      return INITIAL_STATE;
    default:
      return state;
  }
};
